export function saveBlob(payload: BlobPart, fileName: string, mimeType?: string): void {
  const url = URL.createObjectURL(new Blob([payload], mimeType ? { type: mimeType } : undefined));
  const link = document.createElement("a");

  link.style.display = "none";
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);

  try {
    link.click();
  } finally {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
